(function(){
  'use strict';
  var MAP={shop:'pop-shop-menu',learn:'pop-learn-menu'};
  var active=null,trigger=null;
  function panelFor(k){return document.getElementById(MAP[k]);}
  function position(p){
    var g=document.querySelector('#header-group')||document.querySelector('#header-component');
    var b=g?g.getBoundingClientRect().bottom:88;
    p.style.top=Math.max(0,Math.round(b))+'px';
  }
  function hide(p){if(p){p.setAttribute('data-open','false');p.setAttribute('aria-hidden','true');}}
  function closeAll(){
    for(var k in MAP)hide(panelFor(k));
    if(trigger)trigger.setAttribute('aria-expanded','false');
    active=null;trigger=null;
  }
  function openPanel(p,t){
    for(var k in MAP){var o=panelFor(k);if(o&&o!==p)hide(o);}
    position(p);
    p.setAttribute('data-open','true');
    p.setAttribute('aria-hidden','false');
    t.setAttribute('aria-haspopup','true');
    t.setAttribute('aria-expanded','true');
    active=p;trigger=t;
  }
  function navLink(el){
    var a=(el&&el.closest)?el.closest('a'):null;
    if(!a)return null;
    if(!a.closest('#header-component, #header-group, header'))return null;
    var t=(a.textContent||'').trim().toLowerCase();
    if(!MAP[t])return null;
    return {a:a,key:t};
  }
  function switchCategory(btn){
    var panel=btn.closest('.pop-shop');
    if(!panel)return;
    var key=btn.getAttribute('data-cat');
    var cats=panel.querySelectorAll('[data-cat]');
    for(var i=0;i<cats.length;i++){
      if(cats[i]===btn){cats[i].classList.add('is-active');}
      else{cats[i].classList.remove('is-active');}
    }
    var panes=panel.querySelectorAll('[data-pane]');
    for(var j=0;j<panes.length;j++){
      panes[j].hidden=(panes[j].getAttribute('data-pane')!==key);
    }
  }
  document.addEventListener('click',function(e){
    var cat=(e.target&&e.target.closest)?e.target.closest('[data-cat]'):null;
    if(cat){e.preventDefault();switchCategory(cat);return;}
    var hit=navLink(e.target);
    if(hit){
      var p=panelFor(hit.key);
      if(p){
        e.preventDefault();
        if(active===p){closeAll();}else{openPanel(p,hit.a);}
        return;
      }
    }
    if(active&&!active.contains(e.target))closeAll();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});
  window.addEventListener('resize',function(){if(active)position(active);});
  window.addEventListener('scroll',function(){if(active)position(active);},{passive:true});
})();
